var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Card',{staticStyle:{"margin-bottom":"15px"}},[_c('div-date-time'),_c('h1',{staticStyle:{"text-align":"center","padding":"30px"}},[_vm._v("欢迎使用")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }